import { CLINIC_LIST_PATH, CLINIC_ADD_PATH, CLINIC_EDIT_PATH, DEFAULT_DELETE_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import { clinicAction } from './actions';
import { ClinicList, clinicListLoader } from './clinic_list';
import { Clinic, clinicAddLoader, clinicEditLoader} from './clinic';
import { AuthProvider } from '../../auth_provider';

const clinicRoutes = [
  {
    path: CLINIC_LIST_PATH.slice(1),
    element: <ClinicList />,
    loader: clinicListLoader,
    shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
        return AuthProvider.is_authenticated && nextUrl.pathname === CLINIC_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
    },
    children: [
      {
        path: `${DEFAULT_DELETE_PATH.slice(1)}:clinic_id`,
        element: <ActionWindow
            title="Deletar cliente"
            titleOnLoading="Deletando cliente"
            titleOnFail="Falha ao deletar cliente"
            description="Todos os dados relacionados ao cliente serão removidos"
            confirmText="Deletar cliente"
            onCancelPath={CLINIC_LIST_PATH}
            onFailPath={CLINIC_LIST_PATH}
            onSuccessPath={CLINIC_LIST_PATH}
            submitMethod="DELETE"
        />,
        action: clinicAction
      }
    ]
  },
  {
      path: CLINIC_ADD_PATH.slice(1),
      element: <Clinic key="clinic:add" isEdit={false} />,
      loader: clinicAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: clinicAction
  },
  {
      path: `${CLINIC_EDIT_PATH.slice(1)}:clinic_id`,
      element: <Clinic key="clinic:edit" isEdit={true} />,
      loader: clinicEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: clinicAction
  },
];

export default clinicRoutes;